{
  "button": {
    "auto": "স্বয়ংক্রিয়",
    "cancel": "বাতিল করুন",
    "connectWallet": "ওয়ালেট সংযুক্ত করুন",
    "contactSupport": "সাপোর্ট এ যোগাযোগ করুন",
    "continue": "এগিয়ে যান",
    "copyAddress": "ঠিকানা কপি করুন",
    "dark": "অন্ধকার",
    "delete": "মুছে ফেলুন",
    "disconnect": "সংযোগ বিচ্ছিন্ন করুন",
    "done": "সম্পন্ন হয়েছে",
    "getGas": "গ্যাস পান",
    "hide": "গোপন করুন",
    "learnMore": "আরও জানুন",
    "lifiSwap": "লি.ফাই সোওয়াপ",
    "light": "লাইট",
    "max": "সর্বোচ্চ",
    "ok": "ঠিক আছে",
    "okay": "ঠিক আছে",
    "removeSwap": "সোওয়াপ সরান",
    "reset": "পুনরায় সেট করুন",
    "resetSettings": "সেটিংস রিসেট করুন",
    "restartSwap": "সোওয়াপ পুনরায় চালু করুন",
    "reviewGasSwap": "গ্যাস সোওয়াপ পর্যালোচনা করুন",
    "reviewSwap": "সোওয়াপ পর্যালোচনা করুন",
    "seeDetails": "বিস্তারিত দেখুন",
    "showAll": "সবগুলো দেখুন",
    "startGasSwap": "গ্যাস সোওয়াপ করুন",
    "startSwap": "সোওয়াপ শুরু করুন",
    "swap": "সোওয়াপ",
    "tryAgain": "আবার চেষ্টা করুন",
    "viewCoverage": "কভারেজ দেখুন",
    "viewOnExplorer": "এক্সপ্লোরারে দেখুন"
  },
  "format": {
    "currency": "{{value, currency(currency: USD)}}",
    "number": "{{value, number(maximumFractionDigits: 9)}}"
  },
  "header": {
    "activeSwaps": "সোওয়াপ সক্রিয়",
    "checkout": "চেকআউট",
    "from": "থেকে সোওয়াপ করুন",
    "gas": "গ্যাস",
    "gasSwap": "গ্যাস সোওয়াপ",
    "routes": "আপনি পান",
    "selectChain": "চেইন নির্বাচন করুন",
    "selectWallet": "আপনার ওয়ালেট নির্বাচন করুন",
    "settings": "সেটিংস",
    "swap": "সোওয়াপ",
    "swapDetails": "সোওয়াপ বিস্তারিত",
    "swapHistory": "সোওয়াপ ইতিহাস",
    "to": "সোওয়াপ করুন",
    "walletConnected": "ওয়ালেট সংযুক্ত"
  },
  "language": {
    "name": "বাংলা",
    "title": "ভাষা"
  },
  "settings": {
    "enabledBridges": "ব্রিজ সক্রিয়",
    "enabledExchanges": "এক্সচেঞ্জ সক্রিয়",
    "gasPrice": {
      "fast": "দ্রুত",
      "normal": "স্বাভাবিক",
      "slow": "ধীরে",
      "title": "গ্যাসের দাম"
    },
    "routePriority": "রুট অগ্রাধিকার",
    "showDestinationWallet": "গন্তব্য ওয়ালেট দেখান",
    "slippage": "স্লিপেজ"
  },
  "info": {
    "message": {
      "autoRefuel": "আপনার {{chainName}} গ্যাস কম। চালিয়ে যাওয়ার মাধ্যমে, আপনি সোওয়াপ সম্পূর্ণ করার জন্য পর্যাপ্ত গ্যাস পাবেন।",
      "emptyActiveSwaps": "প্রগতিতে সোওয়াপ এখানে প্রদর্শিত হবে। একবার সম্পূর্ণ হলে, সোওয়াপ ইতিহাসে তাদের খুঁজুন।",
      "emptySwapHistory": "সোওয়াপ ইতিহাস শুধুমাত্র স্থানীয়ভাবে সংরক্ষণ করা হয় এবং আপনি যদি আপনার ব্রাউজার ডেটা সাফ করেন তাহলে মুছে ফেলা হবে।",
      "emptyTokenList": "আমরা {{chainName}} চেইনে টোকেন খুঁজে পাইনি বা আপনার কাছে নেই। অনুগ্রহ করে আবার অনুসন্ধান করার চেষ্টা করুন বা অন্য একটি চেইন পছন্দ করুন।",
      "routeNotFound": "অন্য টোকেন সমন্বয় চেষ্টা করুন।"
    },
    "title": {
      "autoRefuel": "গ্যাস পান",
      "emptyActiveSwaps": "কোনো সক্রিয় সোওয়াপ নেই",
      "emptySwapHistory": "কোনো সাম্প্রতিক সোওয়াপ নেই।",
      "routeNotFound": "কোন রুট উপলব্ধ"
    }
  },
  "success": {
    "message": {
      "swapPartiallySuccessful": "আমরা সোওয়াপ সম্পূর্ণ করার চেষ্টা করেছি, কিন্তু {{tokenSymbol}} টোকেনের জন্য {{tool}} -এর লিকুইডিটি ফুরিয়ে গেছে।",
      "swapSuccessful": "এখন {{chainName}} চেইনে {{walletAddress}} ওয়ালেটে {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} আছে।"
    },
    "title": {
      "gasSwapSuccessful": "গ্যাস সোওয়াপ সফল",
      "refundIssued": "রিফান্ড জারি করা হয়েছে",
      "swapPartiallySuccessful": "সোওয়াপ আংশিকভাবে সফল",
      "swapSuccessful": "সোওয়াপ সফল"
    }
  },
  "warning": {
    "message": {
      "deleteActiveSwaps": "সক্রিয় সোওয়াপ শুধুমাত্র স্থানীয়ভাবে সংরক্ষণ করা হয় এবং যদি আপনি সেগুলি মুছে ফেলেন তবে পুনরুদ্ধার করা যাবে না।",
      "deleteSwapHistory": "সোওয়াপ ইতিহাস শুধুমাত্র স্থানীয়ভাবে সংরক্ষণ করা হয় এবং আপনি এটি মুছে ফেললে পুনরুদ্ধার করা যাবে না।",
      "highValueLoss": "প্রাপ্ত টোকেনগুলির মান সোওয়াপ করা টোকেন এবং লেনদেনের খরচের তুলনায় উল্লেখযোগ্যভাবে কম।",
      "insufficientFunds": "সোওয়াপ সম্পূর্ণ করার জন্য আপনার কাছে পর্যাপ্ত তহবিল নেই।",
      "insufficientGas": "সোওয়াপ সম্পূর্ণ করার জন্য আপনার কাছে পর্যাপ্ত গ্যাস নেই। আপনাকে অন্তত যোগ করতে হবে:",
      "rateChanged": "বিনিময় হার পরিবর্তিত হয়েছে। সোওয়াপ চালিয়ে যাওয়ার মাধ্যমে, আপনি নতুন হার গ্রহণ করবেন।",
      "resetSettings": "এটি আপনার রুটের অগ্রাধিকার, স্লিপেজ, গ্যাসের দাম, সক্ষম ব্রিজ এবং এক্সচেঞ্জ রিসেট করবে।"
    },
    "title": {
      "deleteActiveSwaps": "সমস্ত সক্রিয় সোওয়াপ মুছবেন?",
      "deleteSwap": "এই সোওয়াপ মুছে ফেলবেন?",
      "deleteSwapHistory": "সোওয়াপ ইতিহাস মুছবেন?",
      "highValueLoss": "উচ্চ মূল্য ক্ষতি",
      "insufficientGas": "অপর্যাপ্ত গ্যাস",
      "rateChanged": "হার পরিবর্তিত হয়েছে",
      "resetSettings": "রিসেট সেটিংস?"
    }
  },
  "error": {
    "message": {
      "slippageThreshold": "স্লিপেজ সংজ্ঞায়িত থ্রেশহোল্ডের চেয়ে বড়। একটি নতুন উদ্ধৃতি পেতে একটি নতুন রুট অনুরোধ করুন।",
      "transactionFailed": "আরও তথ্যের জন্য ব্লক এক্সপ্লোরার চেক করুন।",
      "transactionNotSent": "লেনদেন পাঠানো হয়নি। আপনার ওয়ালেটে {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} {{chainName}} থেকে যায়।",
      "transactionRejected": "লেনদেন সম্পূর্ণ করতে আপনার স্বাক্ষর প্রয়োজন। আপনার ওয়ালেটে {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} {{chainName}} থেকে যায়।",
      "unknown": "অনুগ্রহ করে আবার চেষ্টা করুন বা সাপোর্ট এর সাথে যোগাযোগ করুন।"
    },
    "title": {
      "balanceIsTooLow": "ব্যালেন্স খুব কম",
      "chainSwitch": "চেইন সুইচ প্রয়োজন",
      "failed": "সোওয়াপ ব্যর্থ হয়েছে",
      "gasLimitIsTooLow": "গ্যাসের সীমা খুব কম",
      "slippageNotMet": "স্লিপেজ শর্ত পূরণ করা হয়নি",
      "transactionCanceled": "লেনদেন বাতিল করা হয়েছে",
      "transactionFailed": "লেনদেন ব্যর্থ হয়েছে",
      "transactionRejected": "স্বাক্ষর প্রয়োজন",
      "transactionUnderpriced": "লেনদেনের দাম কম",
      "transactionUnprepared": "লেনদেন প্রস্তুত করতে অক্ষম",
      "unknown": "কিছু ভুল হয়েছে",
      "walletAddressInvalid": "ওয়ালেট ঠিকানা অবৈধ।",
      "walletAddressRequired": "ওয়ালেট ঠিকানা প্রয়োজন।",
      "walletEnsAddressInvalid": "ওয়ালেট ঠিকানা অবৈধ বা নেটওয়ার্ক ইএনএস সমর্থন করে না।"
    }
  },
  "main": {
    "crossStepDetails": "{{tool}} হয়ে {{from}} থেকে {{to}} পর্যন্ত ব্রিজ",
    "currentAmount": "বর্তমান পরিমাণ",
    "estimatedTime": "{{value}}মি",
    "featuredTokens": "বৈশিষ্ট্যযুক্ত টোকেন",
    "from": "থেকে",
    "fromAmount": "আপনি টাকা পাঠান",
    "gasCost": "গ্যাস খরচ",
    "gasFeeEstimated": "আনুমানিক গ্যাস ফি",
    "gasFeePaid": "গ্যাস ফি প্রদান করা হয়",
    "inProgress": "প্রক্রিয়াধীন",
    "nftStepDetails": "{{tool}} এর মাধ্যমে এনএফটি কিনুন",
    "onChain": "{{chainName}} -এ",
    "otherTokens": "অন্যান্য টোকেন",
    "ownedBy": "মালিক",
    "payWith": "পে দিতে",
    "process": {
      "crossChain": {
        "actionRequired": "দয়াকরে লেনদেন স্বাক্ষর করুন",
        "done": "ব্রিজ লেনদেন নিশ্চিত করা হয়েছে",
        "pending": "ব্রিজ লেনদেনের জন্য অপেক্ষা করছে",
        "started": "ব্রিজ লেনদেনের প্রস্তুতি"
      },
      "receivingChain": {
        "done": "ব্রিজ সম্পন্ন হয়েছে",
        "partial": "ব্রিজ আংশিকভাবে সম্পন্ন হয়েছে",
        "pending": "গন্তব্য চেইন এর জন্য অপেক্ষা",
        "refunded": "ব্রিজ লেনদেন ফেরত করা হয়েছে"
      },
      "swap": {
        "actionRequired": "দয়াকরে লেনদেন স্বাক্ষর করুন",
        "done": "সোওয়াপ সম্পন্ন হয়েছে",
        "pending": "সোওয়াপ লেনদেনের জন্য অপেক্ষা করা হচ্ছে",
        "started": "সোয়াপ লেনদেন প্রস্তুত করা হচ্ছে"
      },
      "switchChain": {
        "actionRequired": "চেইন সুইচ প্রয়োজন",
        "done": "চেইন সফলভাবে সুইচ করা হয়েছে"
      },
      "tokenAllowance": {
        "done": "টোকেন অনুমতি অনুমোদিত",
        "pending": "টোকেন অনুমতির অপেক্ষায়",
        "started": "টোকেন অনুমতির অপেক্ষায়"
      }
    },
    "quotedAmount": "উদ্ধৃত পরিমাণ",
    "rateChange": "রেট পরিবর্তন",
    "receiving": "রিসিভিং",
    "refuelStepDetails": "{{tool}} এর মাধ্যমে গ্যাস পান",
    "routes": "আপনি পান",
    "selectChain": "চেইন",
    "selectChainAndToken": "চেইন এবং টোকেন নির্বাচন করুন",
    "selectToken": "টোকেন",
    "sendToAddress": "{{address}} এ পাঠান",
    "sendToWallet": "অন্য ওয়ালেটে পাঠান",
    "sentToAddress": "{{address}} এ পাঠানো হয়েছে",
    "stepBridge": "ব্রিজ",
    "stepDetails": "লি.ফাই এর মাধ্যমে {{tool}}",
    "stepSwap": "সোওয়াপ",
    "stepSwapAndBridge": "সোওয়াপ এবং ব্রিজ",
    "supportId": "সাপোর্ট আইডি",
    "swapStepDetails": "{{tool}} এর মাধ্যমে {{chain}} এ সোওয়াপ করুন",
    "swapping": "সোওয়াপ",
    "tags": {
      "cheapest": "সস্তা",
      "fastest": "দ্রুত",
      "insurable": "বীমাযোগ্য",
      "insurance": "বীমা",
      "insured": "বীমাকৃত",
      "recommended": "Recommended",
      "safest": "নিরাপদ"
    },
    "to": "প্রতি",
    "tokenOnChain": "{{chainName}} -এ {{tokenSymbol}}",
    "tokenOnChainAmount": "{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} {{chainName}} -এ",
    "tokenSearch": "আপনার টোকেন অনুসন্ধান করুন",
    "valueLoss": "মান ক্ষতি",
    "walletAddressOrEns": "ওয়ালেট ঠিকানা বা ইএনএস নাম"
  },
  "insurance": {
    "bridgeExploits": "ব্রিজের ত্রুটি, হ্যাক বা শোষণ",
    "insure": "ট্রানজিটে টোকেনের ১০০% বীমা করুন।",
    "insured": "আপনি ট্রানজিটের ১০০% টোকেন বীমা করেছেন:",
    "slippageError": "প্রাপ্ত টোকেনগুলির জন্য স্লিপেজে ত্রুটি।"
  },
  "tooltip": {
    "additionalProviderFee": "অতিরিক্ত সেতু, ডেক্স, এবং পরিষেবা ফি।",
    "estimatedNetworkFee": "আনুমানিক নেটওয়ার্ক ফি।",
    "estimatedTime": "মিনিটের মধ্যে আনুমানিক সোওয়াপ কার্যকর করার সময়।",
    "notFound": {
      "text": "আমরা এই পৃষ্ঠাটি খুঁজে পাইনি।",
      "title": "৪০৪"
    },
    "numberOfSteps": "সোওয়াপ পদক্ষেপ একটি সংখ্যা. প্রতিটি ধাপে ১-২ টি লেনদেন থাকতে পারে যার জন্য একটি স্বাক্ষর প্রয়োজন।",
    "progressToNextUpdate": "প্রদর্শিত ডেটা {{value}} সেকেন্ড পরে স্বয়ংক্রিয়ভাবে রিফ্রেশ হবে। ম্যানুয়ালি আপডেট করতে এখানে ক্লিক করুন।",
    "settingsModified": "সেটিংস (পরিবর্তিত)"
  },
  "wallet": {
    "extensionNotFound": "এই ওয়ালেটটি বেছে নেওয়ার আগে দয়া করে নিশ্চিত করুন যে শুধুমাত্র {{name}} ব্রাউজার এক্সটেনশন সক্রিয় আছে।"
  }
}
